import { IDealDirectory, IDealDocument } from 'views/DocumentLibrary/types';
import { TimelineItem } from './types';

interface FlattenedDocument extends IDealDocument {
    directoryPath: string;
}

export const findDocumentInTree = (tree: IDealDirectory | null, docId: number): IDealDocument | null => {
    if (!tree) return null;

    const found = tree.documents?.find((d: IDealDocument) => d.id === docId);
    if (found) return found;

    if (tree.children) {
        for (const child of tree.children) {
            const result = findDocumentInTree(child, docId);
            if (result) return result;
        }
    }

    return null;
};

export const flattenDocumentsFromTree = (
    tree: IDealDirectory,
    currentPath: string = 'Home',
): FlattenedDocument[] => {
    let documents: FlattenedDocument[] = [];

    if (tree.documents) {
        documents = documents.concat(
            tree.documents.map(doc => ({
                ...doc,
                directoryPath: currentPath,
            })),
        );
    }

    if (tree.children) {
        tree.children.forEach(child => {
            documents = documents.concat(flattenDocumentsFromTree(child, child.directoryName));
        });
    }

    return documents;
};

// The API returns a numeric id; coerce to string to match TimelineItem.id and the ids used in URLs.
export const normalizeTimelineId = (timeline: TimelineItem): TimelineItem => (
    { ...timeline, id: String(timeline.id) }
);
